export default __webpack_public_path__ + "locales/fr/DowngradePlanDialog.json?hash=e971b161a8f87ac061e6eba0c1a4ccce";